module.exports = __webpack_public_path__ + "img/Arcane_action_sequence.b8868b0c.webp";